import React from 'react';

import '../css/image-cover.css';
import logo from '../img/light-small-logo.svg';

export default function ImageCover({
    src, className, title, author,
}) {
    return (
        <div className={`image-cover__container ${className}`}>
            <img className="image-cover__image" src={src} />
            <img className="image-cover__logo" src={logo} />
            <p className="image-cover__author">{author && author.split(' ').join('\n').replace(/ *\([^)]*\) */g, '')}</p>
            <p className="image-cover__title">{title}</p>
            <p className="image-cover__time">30 фев. 2020 в 12:00</p>
            <span className="image-cover__overlay" />
        </div>
    );
}
